import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import DropFileUploader from '../../components/form/DropFileUploader';
import FormField from '../../components/form/FormField';
import ReduxFormPackSelect from '../../components/reduxFormMUIWrapper/ReduxFormPackSelect';

const useStyles = makeStyles({
  root: {
    composes: 'flexColumn stretch',
  },
});

let DecorationForm = (props) => {
  const { handleSubmit } = props;
  const classes = useStyles(props);

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <FormField label="Pack" name="pack" component={ReduxFormPackSelect} fullWidth />
      <FormField label="Titre" name="title" fullWidth />
      <FormField label="Description" name="description" fullWidth />
      <FormField label="Image (PNG transparent, bandeau)" name="image" component={DropFileUploader} fullWidth />
      <input type="submit" />
    </form>
  );
};

DecorationForm.propTypes = {
  onSubmit: PropTypes.func,
};

DecorationForm = reduxForm({
  form: 'decorationForm',
  enableReinitialize: true,
})(DecorationForm);

// Edition: the decoration loaded by editDecoration. Creation: the `initialValues` prop (the pack preselected).
DecorationForm = connect((state, ownProps) => {
  if (ownProps.initialValues) return {};
  const { pack, title, description, image } = state.decorations.decoration || {};
  return {
    initialValues: { pack: pack?.objectId ?? '', title, description, image },
  };
})(DecorationForm);

export default DecorationForm;
